// Migrate old Youtube Versions
// set AspectRatio to p tag in old content
// there is no option to set this from css

export default () => { 
    $("p > iframe").parent()
        .addClass('aspect-w-16')
        .addClass('aspect-h-9')
}